/*
    The purpose of this file is to provide a single import for to use the components
    of the library so that we don't have to import and specify every component each
    time we want to use it.
*/
import Alert from "@/components/common/Alert.vue";
import DropdownButton from "@/components/common/DropdownButton.vue";
import EmptyMessage from "@/components/common/EmptyMessage.vue";
import Input from "@/components/common/Input.vue";
import ImagePreview from "@/components/common/AssetPreview.vue";
import ImageCropper from "@/components/common/ImageCropper.vue";
import LoadingLayer from "@/components/common/LoadingLayer.vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import MainNavButton from "@/components/common/MainNavButton.vue";
import Modal from "@/components/Modal/Modal/Modal.vue";
import ModalPortal from "@/components/Modal/Modal/ModalPortal.vue";
import MultiInput from "@/components/common/MultiInput.vue";
import NavigationTabsContainer from "@/components/common/NavigationTabs/Container.vue";
import NavigationTabsItem from "@/components/common/NavigationTabs/Tab.vue";
import NotificationItem from "@/components/common/NotificationItem.vue";
import ProgressBar from "@/components/common/ProgressBar.vue";
import SquareButton from "@/components/common/SquareButton.vue";
import Table from "@/components/common/Table/Table.vue";
import TableHeader from "@/components/common/Table/TableHeader.vue";
import TableHeaderColumn from "@/components/common/Table/TableHeaderColumn.vue";
import TableRow from "@/components/common/Table/TableRow.vue";
import TableRowColumn from "@/components/common/Table/TableRowColumn.vue";
import type { App } from "vue";

const libraryPrefix = "hox";

export function registerComponents(app: App<Element>) {
    /**
     * Inputs
     */
    app.component(`${libraryPrefix}-dropdown-button`, DropdownButton);
    app.component(`${libraryPrefix}-input`, Input);
    app.component(`${libraryPrefix}-multi-input`, MultiInput);
    app.component(`${libraryPrefix}-square-button`, SquareButton);

    /**
     * Layout
     */
    app.component(`${libraryPrefix}-alert`, Alert);
    app.component(`${libraryPrefix}-empty-message`, EmptyMessage);
    app.component(`${libraryPrefix}-loading-layer`, LoadingLayer);
    app.component(`${libraryPrefix}-modal`, Modal);
    app.component(`${libraryPrefix}-modal-portal`, ModalPortal);
    app.component(`${libraryPrefix}-tabs`, NavigationTabsContainer);
    app.component(`${libraryPrefix}-tabs-item`, NavigationTabsItem);
    // Table
    app.component(`${libraryPrefix}-table`, Table);
    app.component(`${libraryPrefix}-table-header`, TableHeader);
    app.component(`${libraryPrefix}-table-header-column`, TableHeaderColumn);
    app.component(`${libraryPrefix}-table-row`, TableRow);
    app.component(`${libraryPrefix}-table-row-column`, TableRowColumn);

    /**
     * Misc.
     */
    app.component(`${libraryPrefix}-image-cropper`, ImageCropper);
    app.component(`${libraryPrefix}-image-preview`, ImagePreview);
    app.component(`${libraryPrefix}-loading-spinner`, LoadingSpinner);
    app.component(`${libraryPrefix}-main-nav-button`, MainNavButton);
    app.component(`${libraryPrefix}-notification-item`, NotificationItem);
    app.component(`${libraryPrefix}-progress-bar`, ProgressBar);
}
